import React, { Component } from 'react';
import { Table, Button } from 'antd';
import NHFetch from "../../../../utils/NHFetch";
import { getLoginUser, hasAuth } from '../../../../utils/NHCore';
const { Column, ColumnGroup } = Table;
import Search from './search'

export default class LstdtjTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataSource: [],
      pagination: {
        total: 0,//数据总数
        pageSize: 20,//每页的条数
        current: 1,//当前页数
        showTotal: (total, range) => `当前${range[0]}-${range[1]}条 总数${total}条`,
        showQuickJumper: true,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100', '200', '500']
      },
      loading:false
    };
    this.params =  {
      sign: "zhxg_yxfw_swbl_lstdtj_final",
      initParams: {
        S_XSLBM_IN:props.xslbm
      },
      sqlParams: {
        userId: getLoginUser().userId
      },
      searchParams: {},
      searchTextMap: {},
      filters: {},
    }
  }

  componentDidMount() {
    const { pagination } = this.state;
    this.loadData({ ...this.params, pagination });
  }
  handleTableChange = (pagination) => {
    this.setState({
      pagination
    });
    this.loadData({ ...this.params, pagination:{...pagination,page:pagination.current} });
  }
  handleExport = () => {
    NHFetch('/proData/gridList/excel/params', 'POST', { params:this.params }).then(res => {
      if (res && res.code === 200) {
        window.open(window.baseUrl + '/swbl/lstd/export?uuid=' + res.data, "_blank")
      }
    })
  }
  loadData = (params) => {
    this.setState({loading:true})
    NHFetch('/proData/gridList', 'POST', params).then(res => {
      if (res && res.code === 200) {
        this.setState({
          dataSource: res.data.list,
          loading:false,
          pagination:{
            ...this.state.pagination,
            total:res.data.total,
          }
        });
      } else {
        this.setState({loading:false});
      }
    }).catch(e=>{
      this.setState({loading:false});
    })
  }
  handleSearch = (values) => {
    const { pagination } = this.state;
    this.params = {...this.params,searchParams:{...values}}
    this.loadData({ ...this.params, pagination });
  }
  render() {
    const { dataSource, pagination,loading } = this.state;
    return (
      <div>
        <Search onSearch={this.handleSearch} xslbm={this.props.xslbm} />
        {hasAuth('zhxg_yxgl_swbl_lstdtj:export') && <Button type='primary' onClick={this.handleExport} style={{ margin: '12px 0px 12px 0px' }}>导出</Button>}
        <Table
          dataSource={dataSource}
          bordered
          pagination={pagination}
          onChange={this.handleTableChange}
          size="middle"
          scroll={{ x: 'calc(700px + 50%)', y: document.body.clientHeight - 450 }}
          rowKey={record => record.SSNJ + record.BMID}
          loading={loading}
        >
          <Column title="序号" dataIndex="ROW_ID" key="ROW_ID" width={50} />
          <Column title="学院" dataIndex="BMMC" key="BMMC" width={150} />
          <Column title="年级" dataIndex="SSNJ" key="SSNJ" />
          <ColumnGroup title="缓交学费住宿费">
            <Column title="人次" dataIndex="HJXFZSFRC" key="HJXFZSFRC" />
            <Column title="金额" dataIndex="HJXFZSFJE" key="HJXFZSFJE" />
          </ColumnGroup>
          <ColumnGroup title="生活补贴">
            <Column title="人次" dataIndex="SHBTRC" key="SHBTRC" />
            <Column title="金额" dataIndex="SHBTJE" key="SHBTJE" />
          </ColumnGroup>
          <ColumnGroup title="生活用品">
            <Column title="人次" dataIndex="SHYPRC" key="SHYPRC" />
            <Column title="金额" dataIndex="SHYPJE" key="SHYPJE" />
          </ColumnGroup>
          <ColumnGroup title="路费补助">
            <Column title="人次" dataIndex="LFBZRC" key="LFBZRC" />
            <Column title="金额" dataIndex="LFBZJE" key="LFBZJE" />
          </ColumnGroup>
          <ColumnGroup title="其他补助">
            <Column title="人次" dataIndex="QTBZRC" key="QTBZRC" />
            <Column title="金额" dataIndex="QTBZJE" key="QTBZJE" />
          </ColumnGroup>
          <ColumnGroup title="生源地信用助学贷款">
            <Column title="人次" dataIndex="SYDDKRC" key="SYDDKRC" />
            <Column title="金额" dataIndex="SYDDKJE" key="SYDDKJE" />
          </ColumnGroup>
          {/* <ColumnGroup title="高校助学贷款">
            <Column title="人次" dataIndex="GXDKRC" key="GXDKRC" />
            <Column title="金额" dataIndex="GXDKJE" key="GXDKJE" />
          </ColumnGroup> */}
        </Table>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./components/swbl/lstdtj/table/index.js